import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { About } from './pages/About';
import { Research } from './pages/Research';
import { Certification } from './pages/Certification';
import { ProductReviews } from './pages/ProductReviews';
import { Media } from './pages/Media';
import { SupportUs } from './pages/SupportUs';
import { Contact } from './pages/Contact';
import { Product } from './pages/Product';
import { Article } from './pages/Article';
import { Video } from './pages/Video';
import { Profile } from './pages/Profile';
import { ScrollToTop } from './components/ScrollToTop';
import { DonorRecognition } from './pages/DonorRecognition';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <ScrollToTop data-id="element-13" />
      <Routes data-id="element-14">
        <Route path="/" element={<App data-id="element-16" />} data-id="element-15" />
        <Route path="/about" element={<About data-id="element-18" />} data-id="element-17" />
        <Route path="/research" element={<Research data-id="element-20" />} data-id="element-19" />
        <Route path="/certification" element={<Certification data-id="element-22" />} data-id="element-21" />
        <Route path="/product-reviews" element={<ProductReviews data-id="element-24" />} data-id="element-23" />
        <Route path="/product/:productId" element={<Product data-id="element-26" />} data-id="element-25" />
        <Route path="/media" element={<Media data-id="element-28" />} data-id="element-27" />
        <Route path="/article/:articleId" element={<Article data-id="element-30" />} data-id="element-29" />
        <Route path="/video/:videoId" element={<Video data-id="element-32" />} data-id="element-31" />
        <Route path="/profile" element={<Profile data-id="element-34" />} data-id="element-33" />
        <Route path="/support-us" element={<SupportUs data-id="element-36" />} data-id="element-35" />
        <Route path="/donor-recognition" element={<DonorRecognition data-id="element-38" />} data-id="element-37" />
        <Route path="/contact" element={<Contact data-id="element-40" />} data-id="element-39" />
      </Routes>
    </BrowserRouter>;
}